// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { ElearningsComponent } from './elearnings.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: ElearningsComponent}
];

/**
 * Elearnings Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class ElearningsRoutingModule {
}
